import React, { useEffect } from 'react';
import Nav from "./Component/Partials/Nav";
import LeftSide from "./Component/Partials/LeftSide";
import RightSide from "./Component/Partials/RightSide";
import MobileNav from "./Component/Partials/MobileNav";
import { Outlet, useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './utils/appToast.css';
import { Fade } from './utils/appToast';
import Agent from './Network/Agent';
import { USER_SELF_FETCH_SUCCESS } from './Reducer/UserSelfReducer';
import PublicRightSide from './Component/Partials/PublicRightSide';
import { GET_DATETIME, GET_TIMEZONE } from './Reducer/TimeZoneSlice';
import { AudioRoomProvider } from './Context/AudioRoomContext';
import AudioRoomMiniPlayer from './Component/AudioRoom/AudioRoomMiniPlayer';

const App = () => {
    const location = useLocation();
    let { id } = useParams();
    let { room } = useParams();
    const dispatch = useDispatch();
    const auth_user = useSelector((state) => state.authReducer)

    useEffect(() => {
        dispatch(USER_SELF_FETCH_SUCCESS(JSON.parse(localStorage.getItem("user_data"))))
        Agent.User.getData(dispatch)

        Agent.Message.chatList(dispatch)
        const currentDate = new Date().toLocaleString();
        dispatch(GET_DATETIME(currentDate))

        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        dispatch(GET_TIMEZONE(timeZone))
        if (auth_user?.accessToken == false && location.pathname == '/') {
            localStorage.clear();
            window.location.href = '/';
        }

    }, [auth_user?.accessToken]);

    const user = useSelector((state) => state.userReducer?.data)

    useEffect(() => {
        if (user) {
            localStorage.setItem("profile_img", user.avatar);
            localStorage.setItem("profile_name", user.name);
            localStorage.setItem("user_data", JSON.stringify(user));
            dispatch(USER_SELF_FETCH_SUCCESS(user));
        }
    }, [user, dispatch]);


    const hideRightSide =
        location.pathname === '/all-story' ||
        location.pathname === '/meeting' ||
        location.pathname === '/videos' ||
        location.pathname === `/video/${id}` ||
        location.pathname === '/audio-rooms' ||
        location.pathname.startsWith('/audio-rooms/');

    return (
        <>
            <AudioRoomProvider>

                <div className={`main-content-wrapper d-flex flex-column ${location.pathname == `/stories/${id}` ? 'story-main-content-wrapper ' : ''}`}>
                    <Nav />

                    {location.pathname == `/meeting-details/${room}` ?
                        <Outlet />
                        :
                        location.pathname == `/stories/${id}` ?
                            <Outlet />
                            :
                            location.pathname == `/shorts/${id}` ?
                                <Outlet />
                                :
                                <>
                                    <LeftSide />

                                    {auth_user?.accessToken == false ?
                                        <>
                                            <PublicRightSide />
                                        </>
                                        :

                                        <>
                                            {hideRightSide ? '' :

                                                <RightSide />

                                            }
                                        </>

                                    }

                                    <div
                                        className={`content-page-box-area  ${hideRightSide ? 'content-box-margin-l' : 'content-box-margin-lr'}`}>
                                        <div className="container">

                                            <Outlet />

                                        </div>
                                    </div>
                                </>
                    }
                </div>

                <AudioRoomMiniPlayer />

                <div className="mobile-bottom-nav d-md-none fixed-bottom shadow-lg mobile-menu">
                    <MobileNav />
                </div>


            </AudioRoomProvider>

            <ToastContainer
                position="bottom-right"
                autoClose={3000}
                hideProgressBar
                newestOnTop
                closeOnClick
                pauseOnFocusLoss
                draggable={false}
                pauseOnHover
                transition={Fade}
            />
        </>
    );
}

export default App;

